/**
 * 毛坯房精装-图片控制
 * @returns
 */
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Button,
  Flex,
  Image,
  useClipboard,
} from "@chakra-ui/react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  bannerSrc: string;
  linkSrc: string;
};

const SmrShareModal = (props: Props) => {
  const { isOpen, onClose, bannerSrc, linkSrc } = props;
  const { onCopy, value, setValue, hasCopied } = useClipboard(linkSrc);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent background="#161922">
        <ModalHeader color="#FFFFFF" fontSize={"18px"}>分享邀请</ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody p={6}>
          <Box w="100%" h="344px" mb="40px">
            <Image w="100%" h="344px" objectFit={"cover"} src={bannerSrc} />
          </Box>
          <Box mb="20px" fontSize={"18px"} color="#FFFFFF">分享作品，邀请好友加入ALDGPT</Box>
          <Box mb="20px" fontSize={"14px"} color="#6C7596">复制链接发送给好友，和Ta一起开启ALDGPT奇幻之旅。</Box>
          <Flex mt="40px" justifyContent={"flex-end"}>
            <Button
              w="100px"
              h="32px"
              color={"#FFFFFF"}
              fontSize="14px"
              fontWeight={"normal"}
              borderRadius={"38px"}
              background={"linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"}
              _hover={{
                background: "linear-gradient(90deg, #496AE1 0%, #66E8E0 100%)",
              }}
              onClick={onCopy}
            >
              {hasCopied ? '已复制' : '复制链接'}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SmrShareModal;
